import { Stack } from '@wegroup/design-system';
import React from 'react';
import { OfferDocumentLink } from '../../../../../types/ProductFactory';
import OfferDocuments from './OfferDocuments';

export type Direction = 'vertical' | 'horizontal';

interface Props {
  title: string;
  documents: OfferDocumentLink[];
}

const SingleOfferDocuments: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  documents,
  ...otherProps
}) => {
  return (
    <Stack bg="gray.ultraLight" p="4" m="2" borderRadius="md" {...otherProps}>
      <h3>{title}</h3>
      <OfferDocuments documents={documents} />
    </Stack>
  );
};

export default SingleOfferDocuments;
